import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { BaseMultipleWidget } from '@website-builder/widgets/base/base-multiple-widget';
import { PopoverDefaultTextStyle } from '@website-builder/widgets/popover/model/popover-default-text-style';
import { PopoverTitleStyle } from '@website-builder/widgets/popover/model/popover-title-style';
import { PopoverSubtitleStyle } from '@website-builder/widgets/popover/model/popover-subtitle-style';
import { PopoverContentStyle } from '@website-builder/widgets/popover/model/popover-content-style';
import { PopoverButtonStyle } from '@website-builder/widgets/popover/model/popover-button-style';
import { PopoverElement } from '@website-builder/widgets/popover/popover-element';
import { PopoverItemStyle } from '@website-builder/widgets/popover/model/popover-item-style';
import { PopoverStyle } from '@website-builder/widgets/popover/model/popover-style';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class PopoverWidget extends BaseMultipleWidget<PopoverElement, PopoverStyle> {
  readonly type = BuilderElementType.Popover;
  src = 'assets/images/builder/placeholders/mountain.png';
  style = new PopoverStyle();
  itemStyle = new PopoverItemStyle();
  elements = [new PopoverElement('assets/images/builder/placeholders/cityview.png')];
  clickMode = 'hover';
  width: number;
  height: number;
  popupWidth: number;
  markerOnHover: boolean;
  defaultText = '';
  defaultTextStyle = new PopoverDefaultTextStyle();
  titleStyle = new PopoverTitleStyle();
  subtitleStyle = new PopoverSubtitleStyle();
  contentStyle = new PopoverContentStyle();
  buttonStyle = new PopoverButtonStyle();

  static normalizeInPlace(widget: PopoverWidget): PopoverWidget {
    const pureWidget = new PopoverWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.src = widget.src ?? pureWidget.src;
    widget.itemStyle = widget.itemStyle ?? pureWidget.itemStyle;
    widget.elements = (widget.elements ?? pureWidget.elements).map(element => PopoverElement.normalizeInPlace(element));
    widget.clickMode = widget.clickMode ?? pureWidget.clickMode;
    widget.width = widget.width ?? pureWidget.width;
    widget.height = widget.height ?? pureWidget.height;
    widget.popupWidth = widget.popupWidth ?? pureWidget.popupWidth;
    widget.markerOnHover = widget.markerOnHover ?? pureWidget.markerOnHover;
    widget.defaultText = widget.defaultText ?? pureWidget.defaultText;

    widget.style = PopoverStyle.normalize(widget.style);
    widget.defaultTextStyle = PopoverDefaultTextStyle.normalize(widget.defaultTextStyle);
    widget.titleStyle = PopoverTitleStyle.normalize(widget.titleStyle);
    widget.subtitleStyle = PopoverSubtitleStyle.normalize(widget.subtitleStyle);
    widget.contentStyle = PopoverContentStyle.normalize(widget.contentStyle);
    widget.buttonStyle = PopoverButtonStyle.normalize(widget.buttonStyle);

    return widget;
  }
}
